<template>
    <div class="tile">
        <div class="tile-title">
            <h2>Payment Method</h2>
        </div>
        <div class="tile-content">
            <v-icon :icon="methodIcon" class="inline-s"/>{{methodLabel}}
        </div>
        <div v-if="isPaymentCard" class="tile-content">
            <v-payment-card
                :type="type"
                :key="type"
                v-for="type in gateway.paymentCardSchemes"
                class="inline-s"/>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import vPaymentCard from '@/components/v-payment-card';
    import _ from '@/common/helpers';
    import detailsMixins from './details-mixins';

    export default {
        name: 'payment-method',
        mixins: [detailsMixins],
        components: {vIcon, vPaymentCard},
        computed: {
            methodLabel() {
                return _.unKebabCase(this.gateway.method);
            },
            methodIcon() {
                if (this.gateway.method === 'payment-card') {
                    return 'credit-card';
                } if (this.gateway.method === 'bank') {
                    return 'bank';
                }
                return 'lock';
            },
            isPaymentCard() {
                return this.gateway.method === 'payment-card';
            },
        },
    };
</script>

<style scoped>

</style>
